<script>
export default {
    name: "TriageForm",

    data() {

        return {
            active: 0,
            activeClass: `bg-gray-100 border-l-2 border-r-2 border-t-2 border-gray-500 
              rounded-t-md z-10 -mb-1`,
            inActiveClass: `bg-gray-300 border-l border-r border-t`,
            encounter: {
              patientID: this.$route.params.patientID,
              visitNo: this.$route.params.visitNO,
              userName: this.$root.username,
              encounterId: 0,
            },
            triage: {
              triageID: this.$route.params.triageID || 0,
              encounterId: this.$route.params.encounterID,
              patientID: this.$route.params.patientID,
              visitNo: this.$route.params.visitNO,
              userName: this.$root.username,
              clinicalProfile: ``,
              notes: ``,
            },
            encounters: [],
            patient: {},
        };
    },

    components: {

      "vitals-form-tab": () => import('./tabs/VitalsForm.vue'),
      "clinical-profile-tab": () => import('./tabs/ClinicalProfile.vue'),
      "illness-history-triage-note-tab": () => import('./tabs/IllnessTriage.vue'),
    },

    mounted() {

      this.$root.loading = true;
      Promise.allSettled([ 
          this.fetchEncounters(), this.fetchPatient(), 
          this.fetchTriageDetails(), ]).then(() => {
            this.$root.loading = false;
      }).catch(() => { this.$root.loading = false; });
    },

    methods: {

        createEncounter() {

          this.$root.loading = true;
          this.$http.post(`Triage/TriageEncounter`, this.encounter).then(response => {
            this.$root.loading = false;
            this.$router.push({ 
                name: `outpatient.encounter.create`,
                params: { 
                  patientID: this.$route.params.patientID, 
                  visitNO: this.$route.params.visitNO, 
                  encounterID: response.data.encounterId, 
                }
              });
            this.fetchEncounters();
          }).catch(() => { this.$root.loading = false; });
        },

        fetchEncounters() {
          let url = `Triage/GetPatientTriageEncounterforVisit`;
              url += `?PatientID=${this.$route.params.patientID}`;
              url += `&VisitNo=${this.$route.params.visitNO}`;

            return this.$http.get(url).then(response => { this.encounters = response.data; })
              .catch(() => {});
        },

        fetchPatient() {
          let url = `PatientRegistration/GetSpecificPatient`;
              url += `?PatientID=${this.$route.params.patientID}`;

            return this.$http.get(url).then(response => {
              this.patient = response.data.length ? response.data[0] : {};
            }).catch(() => {});
        },

        fetchTriageDetails() {
           if(!this.$route.params.encounterID) return Promise.reject();

           let url = `Triage/GetPatientTriageDetailsForEncounter`;
                url += `?PatientID=${this.$route.params.patientID}`;
                url += `&VisitNo=${this.$route.params.visitNO}`;
                url += `&EncounterID=${this.$route.params.encounterID}`

            return this.$http.get(url).then(response => {
                  this.triage = response.data.length ? response.data[0] : {
                      encounterId: this.$route.params.encounterID,
                      patientID: this.$route.params.patientID,
                      visitNo: this.$route.params.visitNO,
                      userName: this.$root.username,
                      clinicalProfile: ``,
                      notes: ``,
                    };
              }).catch(() => {});
        },

        saveData() {
            this.$root.loading = true;
            this.$http.post(`Triage/TriageDetials`, this.triage).then((response) => {
              this.$root.loading = false;
              this.triage.triageID = response.data.triageID;
              if(!this.$route.params.triageID) {
                this.$router.push({
                    name: `outpatient.triage.edit`, 
                    params: { 
                        patientID: this.$route.params.patientID, 
                        visitNO: this.$route.params.visitNO, 
                        encounterID: this.$route.params.encounterID,
                       triageID: response.data.triageID 
                      }
                });
              }
            }).catch(() => { this.$root.loading = false; });
        },
    },
}
</script>
<template>
    <tail-base-layout>
            <template v-slot:content>
                <tail-card>
                  <template v-slot:card-header>
                    <div class="flex w-full md:flex-row sm:flex-col">
                      <h5 class="font-medium text-base">Patient Management: Triage</h5>
                    </div>
                  </template>
                  <template v-slot:card-body>
                      <div class="w-full flex md:flex-row sm:flex-col content-start overflow-auto" 
                      style="height:75vh;">
                          <div class="md:w-1/5 sm:w-full flex flex-wrap content-start border-2 border-blue-500 rounded-md">
                            <div class="w-full p-tiny bg-blue-500 text-right">
                              <button class="btn-sm bg-green-500 text-white whitespace-no-wrap text-xs rounded" @click.stop="createEncounter"><i class="fa fa-plus"></i> Encounter</button>
                            </div>
                            <div class="w-full overflow-auto mt-1">
                              <table class="table table-hover">
                                <thead class="whitespace-no-wrap text-xs text-white bg-blue-500">
                                  <tr>
                                    <th class="p-tiny">ID</th>
                                    <th class="p-tiny">Created By</th>
                                    <th class="p-tiny">Date</th>
                                  </tr>
                                </thead>
                                <tbody class="bg-gray-100 text-xs">
                                  <tr v-for="(enc, idx) in encounters" 
                                    :key="idx" :class="$route.params.encounterID == enc.encounterId ? 
                                      `bg-green-200` : ``"
                                    class="cursor-pointer"
                                    @click.prevent="() => {
                                      $router.push({
                                            name: `outpatient.encounter.create`, 
                                            params: { 
                                              patientID: $route.params.patientID, 
                                              visitNO: $route.params.visitNO, 
                                              encounterID: enc.encounterId, 
                                            }
                                          })
                                    }"  
                                    >
                                    <td class="p-tiny">{{ enc.encounterId }}</td>
                                    <td class="p-tiny">{{ enc.userName }}</td>
                                    <td class="p-tiny">{{ enc.sysDate | dateFormatDT }}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                          <div class="md:w-4/5 sm:w-full px-1">
                              <div class="w-full flex flex-wrap">
                                <div class="w-full p-tiny rounded-t-md bg-green-500 ">
                                  <h5 class="font-bold text-sm text-white">Patient Details</h5>
                                </div>
                                <div class="w-full flex md:flex-row sm:flex-col rounded-b text-base 
                                  border-2 border-green-500 p-1">
                                  <div class="flex-1">
                                    <h5 class="font-medium">
                                      <span class="text-blue-700">{{ patient.names }}</span>
                                    </h5>
                                  </div>
                                  <div class="flex-1">
                                    <h5 class="font-medium">MRN NO: 
                                      <span class="text-blue-700">{{ patient.patienT_ID || `-` }}</span>
                                    </h5>
                                  </div>
                                  <div class="flex-1">
                                    <h5 class="font-medium">IP NO: <span class="text-blue-700">{{ patient.ipfileno || `-` }}</span></h5>
                                  </div>
                                  <div class="flex-1">
                                    <h5 class="font-medium">OP NO: <span class="text-blue-700">{{ patient.opfileno || `-` }}</span></h5>
                                  </div>
                                  <div class="flex-1">
                                    <h5 class="font-medium">DOB: <span class="text-blue-700">{{ patient.dob | dateFormat }}</span></h5>
                                  </div>
                                </div>
                              </div>
                              <div class="w-full flex flex-col content-start p-tiny overflow-auto" v-if="$route.params.encounterID">
                                <ul class="w-full flex border-b-2 border-gray-500">
                                    <li class="-mb-px mr-1">
                                        <a href="javascript:void(0)" @click.prevent="() => { if(!$route.params.encounterID) return;  active=0; }"
                                           class="btn-sm text-sm text-gray-900 rounded-t-md inline-block px-4 font-bold whitespace-no-wrap" 
                                           :class="($route.params.encounterID && active == 0) ? activeClass : inActiveClass">
                                              <i class="fa fa-stethoscope"></i> Vital Readings</a>
                                    </li>
                                    <li class="-mb-px mr-1">
                                        <a href="javascript:void(0)" @click.prevent="() => { if(!$route.params.encounterID) return;  active=1; }"
                                          class="btn-sm text-sm text-gray-900 rounded-t-md inline-block px-4 font-bold whitespace-no-wrap"
                                          :class="($route.params.encounterID && active == 1) ? activeClass : inActiveClass">
                                              <i class="fa fa-list-alt"></i> Clinical Profile</a>
                                    </li>
                                    <li class="-mb-px mr-1">
                                        <a href="javascript:void(0)" @click.prevent="() => { if(!$route.params.encounterID) return;  active=2; }"
                                          class="btn-sm text-sm text-gray-900 rounded-t-md inline-block px-4 font-bold whitespace-no-wrap"
                                          :class="($route.params.encounterID && active == 2) ? activeClass : inActiveClass">
                                              <i class="fa fa-file"></i> Illness History / Triage Notes</a>
                                    </li>
                                  </ul>
                                  <div class="w-full" v-if="active==0">
                                    <vitals-form-tab />
                                  </div>
                                  <div class="w-full" v-if="active==1">
                                    <clinical-profile-tab :triage="triage" />
                                  </div>
                                  <div class="w-full" v-if="active==2">
                                    <illness-history-triage-note-tab :triage="triage" />
                                  </div>
                              </div>
                              <div class="w-full flex flex-wrap p-4" v-else>
                                  <div class="w-full flex justify-center">
                                      <img style="height:45vh; width:80vh;" 
                                          src="/un-authorized.svg" alt="" srcset="">
                                  </div>
                                  <div class="w-full text-center">
                                      <h5 class="font-bold text-xl text-red-500">Create / Use an encounter</h5>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </template>
                  <template v-slot:card-footer>
                    <div class="w-full text-right">
                        <router-link :to="{ name: `outpatient.outpatient-list.index`}" class="btn-danger btn-sm rounded text-sm mr-4"><i class="fa fa-caret-left"></i> Back</router-link>
                        <button  v-if="$route.params.encounterID" class="btn-primary btn-sm rounded text-sm" @click.prevent="saveData"><i class="fa fa-save"></i> Save</button>
                    </div>
                  </template>
                </tail-card>
            </template>
    </tail-base-layout>
</template>
